import React from 'react'
import {
  getTaskMemberInitials,
  resolveTaskMemberImageUrl,
} from './taskBoardUtils'

const TaskMemberAvatar = ({ member, size = 'medium' }) => {
  const [imageFailed, setImageFailed] = React.useState(false)
  const imageUrl = resolveTaskMemberImageUrl(member?.imageName)
  const name = member?.name || 'Assigned administrator'

  React.useEffect(() => {
    setImageFailed(false)
  }, [imageUrl])

  if (imageUrl && !imageFailed) {
    return (
      <img
        className={`task-member-avatar task-member-avatar--${size}`}
        src={imageUrl}
        alt={name}
        title={name}
        onError={() => setImageFailed(true)}
      />
    )
  }

  return (
    <span
      className={`task-member-avatar task-member-avatar--${size} task-member-avatar--initials`}
      title={name}
      aria-label={name}
    >
      {getTaskMemberInitials(name)}
    </span>
  )
}

export default TaskMemberAvatar
